// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2_Wqf","col":"styles_col__3WR2e"};